import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, Teleport as _Teleport, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d1275a6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "price-group" }
const _hoisted_2 = { class: "kps-price" }
const _hoisted_3 = {
  key: 0,
  class: "icon icon-spinner2"
}
const _hoisted_4 = { class: "m2-price" }
const _hoisted_5 = {
  key: 0,
  class: "icon icon-spinner2"
}
const _hoisted_6 = { class: "price-group" }
const _hoisted_7 = { class: "kps-price" }
const _hoisted_8 = {
  key: 0,
  class: "icon icon-spinner2"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "m2-price" }
const _hoisted_11 = {
  key: 0,
  class: "icon icon-spinner2"
}

import { computed } from 'vue';
import { useStore } from 'vuex';
import FormattedPrice from './FormattedPrice.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderPricingInformation',
  setup(__props) {

const store = useStore();
const settings = window.measurementSelectorVariables.settings;

const shouldShowSpinner = computed(() => (store.getters.usePriceFromServer && store.getters.isRetrievingProperties) || store.getters.isRetrievingBulkPricing);
const totalPriceIncVat = computed(() => store.getters.getPriceIncVat);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#measurements-selector-price-desktop" }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (shouldShowSpinner.value)
            ? (_openBlock(), _createElementBlock("i", _hoisted_3))
            : (_openBlock(), _createBlock(FormattedPrice, {
                key: 1,
                price: totalPriceIncVat.value,
                dataTestID: "product_side_bar_price_incl"
              }, null, 8, ["price"]))
        ]),
        _createElementVNode("div", _hoisted_4, [
          (shouldShowSpinner.value)
            ? (_openBlock(), _createElementBlock("i", _hoisted_5))
            : (_openBlock(), _createBlock(FormattedPrice, {
                key: 1,
                price: _unref(settings).pricePerM2IncludingTax,
                dataTestID: "product_side_bar_price_excl"
              }, null, 8, ["price"])),
          _createTextVNode(" / m² ")
        ])
      ])
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "#measurements-selector-price-mobile" }, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (shouldShowSpinner.value)
            ? (_openBlock(), _createElementBlock("i", _hoisted_8))
            : (_openBlock(), _createElementBlock("span", _hoisted_9, [
                _createVNode(FormattedPrice, {
                  price: totalPriceIncVat.value,
                  dataTestID: "product_side_bar_price_incl"
                }, null, 8, ["price"])
              ]))
        ]),
        _createElementVNode("div", _hoisted_10, [
          (shouldShowSpinner.value)
            ? (_openBlock(), _createElementBlock("i", _hoisted_11))
            : (_openBlock(), _createBlock(FormattedPrice, {
                key: 1,
                price: _unref(settings).pricePerM2IncludingTax,
                dataTestID: "product_side_bar_price_excl"
              }, null, 8, ["price"])),
          _createTextVNode(" / m² ")
        ])
      ])
    ]))
  ], 64))
}
}

})